export const RESULT = [
  {id: 1, name: "Đạt"},
  {id: 2, name: "Không đạt"},
];

export const EVALUATE_STATUS = {
  NOT_RATE_YET: {
    code: 1,
    name: "Chưa đánh giá",
  },
  EVALUETING: {
    code: 2,
    name: "Đang đánh giá",
  },
  EVALUATED: {
    code: 3,
    name: "Đã đánh giá",
  },
};

export const TYPE_CONFIRM_DIALOG = {
  COMPLETE_EVALUATE: "completeEvaluate",
};

export const MESSAGE_CONFIRM_DIALOG = {
  [TYPE_CONFIRM_DIALOG.COMPLETE_EVALUATE]: "Bạn có chắc chắn muốn hoàn thành đánh giá các tiêu chí đã chọn không?",
};
